/**
 * The auth gate (WS-D D2′) — a full-screen overlay that covers the legacy
 * dashboard until the user is signed in.
 *
 * Login-only: the demo/dev site uses admin-provisioned accounts (an admin
 * creates each user in Cognito with a permanent password), so there is no
 * sign-up / verify / forgot-reset flow — just a Sign-In page. (Those views were
 * prototyped this session and parked for prod; re-port from world-cup-v2 when
 * the product goes self-serve — see bento-planning first-demo-plan §7.)
 *
 * Rendered by <App> only when the app is a real (Cognito-configured) build AND
 * nobody is signed in — so unconfigured builds (local dev, CI/VRT) never see it
 * and the dashboard renders exactly as before.
 */

import SignIn from "./SignIn.js";

export default function AuthOverlay() {
  return (
    <div className="auth-overlay">
      <div className="auth-overlay-inner">
        <SignIn />
      </div>
    </div>
  );
}
